module.exports = (app) => app.directive('eprocFeature', /* @ngInject */ function (featureToggleService) {

    return {
        restrict: 'AE',
        priority: 10000,
        // transclude: true,
        scope: {
            featureName: '@',
        },
        link: function ($scope, element) {
            console.log($scope.featureName)
            // only apply if a feature is provided
            if ($scope.featureName) {
                // hide element during the checking process
                element.addClass('d-none');
                featureToggleService.isActive($scope.featureName).then((response) => {
                    if (!response.active) {
                        // remove element (and it's children) from dom
                        element.children().remove();
                        element.remove();
                    } else {
                        element.removeClass('d-none');
                    }
                    $scope.$apply();
                }, (e) => {
                    console.error(e);
                });
            }
        }
    }

});
